/* eslint max-len: 0 */
/**
 * Map the copy for available sidebar block tooltips
 * @TODO connect this text to the [i] buttons in the sidebar
 */
export default {
  'Locations': {
    'table': 'Use the check boxes to display selected geographies. Not all geographies are available for every indicator.',
    'graph': 'Use the check boxes to select geographies to display in the graph.',
    'map': 'Use the check boxes to display data for selected geographies in the table below the map. All available data for the entire United States will be mapped, regardless of geographies selected.',
  },
  'Data View': {
    'table': 'Use the check boxes to display selected geographies. Not all geographies are available for every indicator.',
    'graph': 'Use the check boxes to select geographies to display in the graph.',
    'map': 'Use the check boxes to display data for selected geographies in the table below the map. All available data for the entire United States will be mapped, regardless of geographies selected.',
  },
  'Distributions': {
    'table': 'Use the check boxes to select distributions to display.',
    'graph': 'Use the check boxes to select distributions to display in the graph.',
    'map': 'Use the check boxes to select distributions to display in the map. Only one distribution can be mapped at a time.',
  },
  'Timeframe': {
    'table': 'Use the dropdown to select a timeframe. If older data are not availale, the dropdown menu option will not appear.',
    'graph': 'Use the dropdown menus to select a timeframe to graph.',
    'map': 'Use the dropdown menu to select a timeframe.',
  },
};



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/config/tooltips.js